import React, { useEffect, useState } from "react";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import FsLightbox from "fslightbox-react";
import { Banner } from "../../components/Banner/Banner";
import {
  bloginnerban,
  facebook,
  gallery1,
  leftarrow,
  mainimg,
  moreblog1,
  moreblog2,
  moreblog3,
  coloredArrow,
  playicon,
  whatsapp,
  linkedinblog,
  twitterblog,
  copy,
  mainimgmob,
  bannerInner,
  bannerInner2,
} from "../../images";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { Link, NavLink } from "react-router-dom";
//utils
import { reduceDescSize } from "../../helpers/utils";

import "./BlogInner2.scss";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const BlogInner = () => {
  const { width } = useWindowDimensions();
  const [copied, setCopied] = useState(false);
  const [toggler, setToggler] = useState(false);
  const [vidLink, setVidLink] = useState("");

  const blogDateArr = [
    {
      date: "June 2, 2022",
      category: "Lorem Ipsum",
      company: "Sanathan",
    },
  ];

  const blogDescArr = [
    {
      id: 1,
      heading: "Recycled Pet Chips 101: Explained",
      desc1:
        "The fabrics and yarn industry is an essential component of the textile and apparel industries. To remain competitive, these industries strive for continuous improvement and, as a result, are always on the lookout for creative solutions to suit shifting expectations and industry standards. These standards are primarily focused on long-term solutions such as recycling, waste reduction, production efficiency, and closed-loop manufacturing. With increased government participation, these standards are becoming increasingly important for trade and business.<br/><br/> Customers will continue to pay where they see innovation. There are numerous innovative ideas in the fibre and fabric manufacturing industries. A variety of yarn and fabric categories are being worked on. In this article, let us dive into the new developments in Yarns & Fabrics.<br/><br/> <strong> Contemporary Yarns & Fabrics Developments You Need To Know:</strong><br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>1. Sustainable Solutions</strong><br/> Sustainability is a growing concern for companies, equipment and fabric makers, and consumers. The textile sector, second only to oil, is one of the most significant contributors to negative environmental effects. According to the UN Partnership on Sustainable Fashion, it accounts for around 10% of world greenhouse gas emissions and 20% of global wastewater production. As a result, textile companies&#39; need to change their approach to manufacturing and production is drastically increasing. Fibres and yarns are being developed by companies all over the world as new solutions to the need for more sustainable systems. Various companies have demonstrated two significant sustainability initiatives: circular fashion and closed-loop systems.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>2. Circular Fashion</strong><br/> The modern textile industry has a linear economic structure with a very limited lifecycle – textiles are sourced, produced, and then discarded. Although rapid, this economic structure is wasteful, unsustainable, and harmful to the environment. To address this issue, the reuse economy has recently received a lot of attention. This platform improves the linear process by reusing fabrics several times. However, in a linear economy, this type of cycle finally ends when the item can no longer be repurposed or recycled and ends up in the landfill. This economic structure is known as a circular economy or circular fashion, and it not only addresses the potential to extend the life of a product, but it also preserves the environment. Every part of the production process in a circular fashion business is pushed to be circular, ethical, and ultimately environmentally friendly and sustainable. This involves material recycling, the use of biodegradable solutions, the ethical procurement of raw materials, and the use of more efficient manufacturing and production processes.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>3. Closed-Loop Production</strong><br/> More brands than ever before are providing semi-closed loop versions of sustainably derived items. Upcycling is a semi-closed loop production process that involves employing recycled materials to create new products. Closed-loop production systems utilise material waste generated during the manufacturing process for extra products and use recycled products to make new items. For instance, polyester, which accounts for more than half of the fibres used in the textile and garment industries; can be recycled and utilised for a considerably longer period, resulting in a closed-loop system which is one of the most critical parts of adopting a sustainable manufacturing system.<br/><br/> Apart from this, the other new developments are:<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> Traditional Fibres</strong> <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;●&nbsp;&nbsp; Colourful cotton is grown to generate colourful items.<br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;●&nbsp;&nbsp;&nbsp;Rain suit made of organically grown, water repellent, waxed cotton.</br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;●&nbsp;&nbsp;&nbsp;Wool and cotton or cotton and cashmere fibres are compatible and shrink resistant.<br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;●&nbsp;&nbsp;&nbsp;Non-iron or stain-resistant treatments are added to cotton and linen fibres to make them more durable. <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Synthetic Polymers</strong><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;●&nbsp;&nbsp;&nbsp;Polypropylene, which has historically been used in packing and sacking, yields a robust, delicate, waterproof fabric with good thermal properties. <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;●&nbsp;&nbsp;&nbsp;Polyethene, which has traditionally been used for banners and packaging, can now be utilised for disposable fashion items.<br/><br/><strong> About Sanathan Textiles</strong><br/> Sanathan Textiles is a polyester manufacturer and a global supplier of Cotton Yarns, Polyester Yarns and Yarns for Technical Textiles. With 3 yarn business verticals, we offer a wide variety of yarns that are used by various sectors and industries, across applications and end-uses. Technologically advanced and environmentally conscious manufacturing setup enables us to offer customers value-added yarns, niche yarns, functional yarns and a wide range of coloured yarns. Sanathan Textiles is committed to providing Value added Innovative Yarns for the Fabric of our Lives.",
    },
  ];

  const moreblogsArr = [
    {
      img: moreblog1,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog2,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog3,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog2,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
  ];

  const galleryArr = [
    {
      id: 1,
      type: "video",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 2,
      type: "image",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 3,
      type: "video",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 4,
      type: "image",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
  ];

  useEffect(() => {
    var gallery_swiper_container = new Swiper(
      ".swiper-container.gallery_swiper_container",
      {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          prevEl: ".bloginner_sec2 .left_arrow",
          nextEl: ".bloginner_sec2 .right_arrow",
        },
        breakpoints: {
          767: {
            slidesPerView: 1.6,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 2.7,
            spaceBetween: 10,
          },
        },
        // loop: true,
        // centeredSlides: true,
        // loopedSlides: thumbArr.length, //how many slides it should duplicate
      }
    );
    var moreblogs_swiper_container = new Swiper(
      ".swiper-container.moreblogs_swiper_container",
      {
        slidesPerView: 3,
        spaceBetween: 40,
        loop: false,
        navigation: {
          prevEl: ".bloginner_sec3 .left_arrow",
          nextEl: ".bloginner_sec3 .right_arrow",
        },
        breakpoints: {
          300: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          767: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      }
    );
  });

  useEffect(() => {
    if (copied) {
      let copiedTimeout = setTimeout(() => {
        setCopied(false);
      }, 3000);
      return () => {
        clearTimeout(copiedTimeout);
      };
    }
  }, [copied]);

  const dateList = blogDateArr.map((item) => (
    <>
      <p className="blog_date">{item.date} | </p>
      <p className="blog_category"> {item.category} </p>
      <p className="blog_company">| {item.company}</p>
    </>
  ));

  const descList = blogDescArr.map((item) => (
    <>
      <p
        className="blog_desc"
        dangerouslySetInnerHTML={{ __html: item.desc1 }}
      />
    </>
  ));

  const galleryVideoImageList = galleryArr.length
    ? galleryArr.map((item, i) => (
        <div className="swiper-slide" key={i}>
          {item.type == "video" ? (
            <>
              <div
                className="video_wrapper_div"
                onClick={() => handleImageWrapperClick(item.ytLink)}
              >
                <div className="content">
                  <img
                    src={item.image}
                    alt="Sanathan video gallery img"
                    loading="lazy"
                    className="gallery_img"
                  />
                  <div className="content-overlay"></div>
                  <img
                    src={playicon}
                    alt="Sanathan coloredArrow img"
                    loading="lazy"
                    className="playicon"
                    onClick={() => handleImageWrapperClick(item.ytLink)}
                  />
                  {/* <h2 className="galleryImageName">{item.title}</h2> */}
                </div>

                {/* <h2 className="galleryImageName">{item.title}</h2> */}
              </div>
            </>
          ) : (
            <>
              <div className="content">
                <img
                  src={item.image}
                  alt="Sanathan blog gallery img"
                  loading="lazy"
                  className="gallery_img"
                />
                <div className="content-overlay"></div>
                {/* <h2 className="galleryImageName">{item.title}</h2> */}
              </div>
            </>
          )}
        </div>
      ))
    : null;

  const moreblogsList = moreblogsArr.map((item, i) => (
    <>
      <li className="swiper-slide moreblog_detail_wrapper">
        <Link to="/blog-inner" key={i}>
          <div className="imageanimate zoom-out">
            <img
              src={item.img}
              alt="Sanathan our blog img"
              loading="lazy"
              className="moreblog_img"
            />
            {/* <div className="content-overlay"></div> */}
          </div>
          <div className="text_container">
            <h1 className="moreblog_date">{item.date}</h1>
            <div className="verticle_line"> | </div>
            <h1 className="moreblog_category"> {item.category}</h1>
            <h1 className="moreblog_name">{item.title}</h1>
            <p className="moreblog_synopsis">
              {reduceDescSize(item.desc, 100)}
            </p>
            <div className="moreblog_cta_wrapper"></div>
          </div>
        </Link>
      </li>
    </>
  ));

  const handleImageWrapperClick = (videoLink) => {
    setToggler(!toggler);
    setVidLink(videoLink);
  };

  const copyUrl = () => {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setCopied(true);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <MetaDecorator
        canonicalLink="https://www.sanathan.com/blogs/development-yarn-fibers"
        metaTitle="Latest Yarn, And Fabric Developments | Sanathan Textiles"
        metaDesc=" The fabrics and yarn industry is an essential component of the textile and apparel industries. Learn more about the trends in this blog."
      />
      {/* <Banner
        imgSrc="https://via.placeholder.com/1920x300"
        breadcrumbWord1="Home"
        breadcrumbWord3="Blogs"
        breadcrumbWord4={blogDescArr[0].heading}
        link3="blogs"
        disabled
      /> */}
      <section className="bloginner_sec1" data-aos="fade-in">
        <div className="wrapper">
          {/* <div className="breadcrumb_styles">Home {">"} Blog Inner</div> */}
          {/* <div className="blog_heading">
            Blog Heading will come here lorem ipsum lorem ipsum example text
            here
          </div> */}
          <img
            className="mainimg"
            src={bannerInner2}
            alt="Sanathan blog inner img"
          />
          <div className="row social_icon_date">
            <div className="col-md-6 col-lg-4 datecat_list">
              {/* {dateList} */}
            </div>
            <div className="col-md-1 col-lg-4"></div>
            <div className="col-md-5 col-lg-4">
              {width < 767 ? <h2 className="share_title">Share</h2> : null}
              <div className="social_main_wrapper">
                <ul className="social_icons">
                  {width > 767 ? (
                    <li className="social_icon_li">
                      <h2 className="share_title">Share</h2>
                    </li>
                  ) : null}
                  <li className="social_icon_li">
                    <FacebookShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={facebook}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </FacebookShareButton>
                  </li>
                  <li className="social_icon_li">
                    <WhatsappShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={whatsapp}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </WhatsappShareButton>
                  </li>
                  <li className="social_icon_li">
                    <TwitterShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={twitterblog}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </TwitterShareButton>
                  </li>
                  <li
                    className="social_icon_li social_icon_li_copy"
                    onClick={copyUrl}
                  >
                    <span className="social_icon">
                      <img
                        src={copy}
                        alt="Sanathan copy url logo"
                        loading="lazy"
                      />
                    </span>
                    <span className="social_name">
                      {!copied ? "" : "Copied!"}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="horizontal_line"></div>
          <h1 className="blog_inner_name">
            What Are the Latest Yarn, And Fabric Developments?
          </h1>

          {/* <div>
            The fabrics and yarn industry is an essential component of the
            textile and apparel industries. To remain competitive, these
            industries strive for continuous improvement and, as a result, are
            always on the lookout for creative solutions to suit shifting
            expectations and industry standards. These standards are primarily
            focused on long-term solutions such as recycling, waste reduction,
            production efficiency, and closed-loop manufacturing. With increased
            government participation, these standards are becoming increasingly
            important for trade and business. Customers will continue to pay
            where they see innovation. There are numerous innovative ideas in
            the fibre and fabric manufacturing industries. A variety of yarn and
            fabric categories are being worked on. In this article, let us dive
            into the new developments in Yarns &amp; Fabrics. Contemporary Yarns
            &amp; Fabrics Developments You Need To Know: 1. Sustainable
            Solutions Sustainability is a growing concern for companies,
            equipment and fabric makers, and consumers. The textile sector,
            second only to oil, is one of the most significant contributors to
            negative environmental effects. According to the UN Partnership on
            Sustainable Fashion, it accounts for around 10% of world greenhouse
            gas emissions and 20% of global wastewater production. As a result,
            textile companies&#39; need to change their approach to
            manufacturing and production is drastically increasing. Fibres and
            yarns are being developed by companies all over the world as new
            solutions to the need for more sustainable systems. Various
            companies have demonstrated two significant sustainability
            initiatives: circular fashion and closed-loop systems. 2. Circular
            Fashion The modern textile industry has a linear economic structure
            with a very limited lifecycle – textiles are sourced, produced, and
            then discarded. Although rapid, this economic structure is wasteful,
            unsustainable, and harmful to the environment. To address this
            issue, the reuse economy has recently received a lot of attention.
            This platform improves the linear process by reusing fabrics several
            times. However, in a linear economy, this type of cycle finally ends
            when the item can no longer be repurposed or recycled and ends up in
            the landfill. This economic structure is known as a circular economy
            or circular fashion, and it not only addresses the potential to
            extend the life of a product, but it also preserves the environment.
            Every part of the production process in a circular fashion business
            is pushed to be circular, ethical, and ultimately environmentally
            friendly and sustainable. This involves material recycling, the use
            of biodegradable solutions, the ethical procurement of raw
            materials, and the use of more efficient manufacturing and
            production processes. 3. Closed-Loop Production More brands than
            ever before are providing semi-closed loop versions of sustainably
            derived items. Upcycling is a semi-closed loop production process
            that involves employing recycled materials to create new products.
            Closed-loop production systems utilise material waste generated
            during the manufacturing process for extra products and use recycled
            products to make new items. For instance, polyester, which accounts
            for more than half of the fibres used in the textile and garment
            industries; can be recycled and utilised for a considerably longer
            period, resulting in a closed-loop system which is one of the most
            critical parts of adopting a sustainable manufacturing system. Apart
            from this, the other new developments are: Traditional Fibres ●
            Colourful cotton is grown to generate colourful items. ● Rain suit
            made of organically grown, water repellent, waxed cotton. ● Wool and
            cotton or cotton and cashmere fibres are compatible and shrink
            resistant. ● Non-iron or stain-resistant treatments are added to
            cotton and linen fibres to make them more durable. Synthetic
            Polymers ● Polypropylene, which has historically been used in
            packing and sacking, yields a robust, delicate, waterproof fabric
            with good thermal properties. ● Polyethene, which has traditionally
            been used for banners and packaging, can now be utilised for
            disposable fashion items. About Sanathan Textiles Sanathan Textiles
            is a polyester manufacturer and a global supplier of Cotton Yarns,
            Polyester Yarns and Yarns for Technical Textiles. With 3 yarn
            business verticals, we offer a wide variety of yarns that are used
            by various sectors and industries, across applications and end-uses.
            Technologically advanced and environmentally conscious manufacturing
            setup enables us to offer customers value-added yarns, niche yarns,
            functional yarns and a wide range of coloured yarns. Sanathan
            Textiles is committed to providing Value added Innovative Yarns for
            the Fabric of our Lives.
          </div> */}
          <div className="left_section_paragraphs">
            <p>
              The fabrics and yarn industry is an essential component of the
              textile and apparel industries. To remain competitive, these
              industries strive for continuous improvement and, as a result, are
              always on the lookout for creative solutions to suit shifting
              expectations and industry standards. These standards are primarily
              focused on long-term solutions such as recycling, waste reduction,
              production efficiency, and closed-loop manufacturing. With
              increased government participation, these standards are becoming
              increasingly important for trade and business.
            </p>
            <br />
            <br />
            <p>
              {" "}
              Customers will continue to pay where they see innovation. There
              are numerous innovative ideas in the fibre and fabric
              manufacturing industries. A variety of yarn and fabric categories
              are being worked on. In this article, let us dive into the new
              developments in Yarns &amp; Fabrics.
            </p>
            <br />
            <br />
            <strong>
              <p>
                {" "}
                Contemporary Yarns &amp; Fabrics Developments You Need To Know:
              </p>
            </strong>
            <br />
            <br />
            {/* <span className="span-one"> */}
            <strong>
              <p className="margin-left">1. Sustainable Solutions</p>
            </strong>
            {/* </span> */}
            <br />
            <p>
              {" "}
              Sustainability is a growing concern for companies, equipment and
              fabric makers, and consumers. The textile sector, second only to
              oil, is one of the most significant contributors to negative
              environmental effects. According to the UN Partnership on
              Sustainable Fashion, it accounts for around 10% of world
              greenhouse gas emissions and 20% of global wastewater production.
              As a result, textile companies&#39; need to change their approach
              to manufacturing and production is drastically increasing. Fibres
              and yarns are being developed by companies all over the world as
              new solutions to the need for more sustainable systems. Various
              companies have demonstrated two significant sustainability
              initiatives: circular fashion and closed-loop systems.
            </p>
            <br />
            <br />
            <strong>
              <p className="margin-left">2. Circular Fashion</p>
            </strong>
            <br />
            <p>
              {" "}
              The modern textile industry has a linear economic structure with a
              very limited lifecycle – textiles are sourced, produced, and then
              discarded. Although rapid, this economic structure is wasteful,
              unsustainable, and harmful to the environment. To address this
              issue, the reuse economy has recently received a lot of attention.
              This platform improves the linear process by reusing fabrics
              several times. However, in a linear economy, this type of cycle
              finally ends when the item can no longer be repurposed or recycled
              and ends up in the landfill. This economic structure is known as a
              circular economy or circular fashion, and it not only addresses
              the potential to extend the life of a product, but it also
              preserves the environment. Every part of the production process in
              a circular fashion business is pushed to be circular, ethical, and
              ultimately environmentally friendly and sustainable. This involves
              material recycling, the use of biodegradable solutions, the
              ethical procurement of raw materials, and the use of more
              efficient manufacturing and production processes.
            </p>
            <br />
            <br />
            <strong>
              <p className="margin-left">3. Closed-Loop Production</p>
            </strong>
            <br />
            <p>
              More brands than ever before are providing semi-closed loop
              versions of sustainably derived items. Upcycling is a semi-closed
              loop production process that involves employing recycled materials
              to create new products. Closed-loop production systems utilise
              material waste generated during the manufacturing process for
              extra products and use recycled products to make new items. For
              instance, polyester, which accounts for more than half of the
              fibres used in the textile and garment industries; can be recycled
              and utilised for a considerably longer period, resulting in a
              closed-loop system which is one of the most critical parts of
              adopting a sustainable manufacturing system.
            </p>
            <br />
            <br /> <p>Apart from this, the other new developments are:</p>
            <br />
            <br />
            <strong>
              <p className="margin-left2">Traditional Fibres</p>
            </strong>
            <br />
            <ul className="margin-left3">
              <li>
                <p>Colourful cotton is grown to generate colourful items.</p>
              </li>
              <br />
              <li>
                <p>
                  Rain suit made of organically grown, water repellent, waxed
                  cotton.
                </p>
              </li>
              <br />
              <li>
                <p>
                  {" "}
                  Wool and cotton or cotton and cashmere fibres are compatible
                  and shrink resistant.
                </p>
              </li>
              <br />
              <li>
                <p>
                  {" "}
                  Non-iron or stain-resistant treatments are added to cotton and
                  linen fibres to make them more durable.
                </p>
              </li>
            </ul>
            <br />
            <br />
            <strong>
              <p className="margin-left2">Synthetic Polymers</p>
            </strong>
            <br />
            <ul className="margin-left3">
              <li>
                <p>
                  Polypropylene, which has historically been used in packing and
                  sacking, yields a robust, delicate, waterproof fabric with
                  good thermal properties.
                </p>
              </li>
              <br />
              <li>
                <p>
                  Polyethene, which has traditionally been used for banners and
                  packaging, can now be utilised for disposable fashion items.
                </p>
              </li>
            </ul>
            <br />
            <br />
            <strong>
              <p>About Sanathan Textiles</p>
            </strong>
            <br />
            <p>
              {" "}
              Sanathan Textiles is a{" "}
              <a href="/products/polyester-yarn"> polyester manufacturer</a> and
              a global supplier of{" "}
              <a href="/products/cotton-yarn">Cotton Yarns </a>, Polyester Yarns
              and Yarns for Technical Textiles. With 3 yarn business verticals,
              we offer a wide variety of yarns that are used by various sectors
              and industries, across applications and end-uses. Technologically
              advanced and environmentally conscious manufacturing setup enables
              us to offer customers value-added yarns, niche yarns, functional
              yarns and a wide range of coloured yarns. Sanathan Textiles is
              committed to providing Value added Innovative Yarns for the Fabric
              of our Lives.
            </p>
          </div>
        </div>
      </section>

      {/* {galleryVideoImageList && (
        <section className="bloginner_sec2" data-aos="fade-up">
          <div className="wrapper">
            <div className="heading_arrow_flex">
              <div className="gallery_heading">Gallery</div>
              {width > 767 ? (
                <div className="navigations">
                  <button className="left_arrow">Previous</button>
                  <button className="right_arrow">Next</button>
                </div>
              ) : null}
            </div>
            <div className="gallery_slider_wrapper">
              <div className="swiper-container gallery_swiper_container">
                <div className="swiper-wrapper">{galleryVideoImageList}</div>
              </div>
              {width < 767 ? (
                <div className="arrows_wrapper">
                  <div className="navigations">
                    <button className="left_arrow">Previous</button>
                    <button className="right_arrow">Next</button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </section>
      )} */}

      {/* <section className="bloginner_sec3" data-aos="fade-up">
        <div className="horizontal_line"></div>
        <div className="wrapper">
          <div className="heading_arrow_flex2">
            <h2 className="moreblog_heading">More Blogs</h2>
            {width > 767 ? (
              <div className="navigations">
                <button className="left_arrow">Previous</button>
                <button className="right_arrow">Next</button>
              </div>
            ) : null}
          </div>

          <div className="moreblogs_wrapper">
            <div className="swiper-container moreblogs_swiper_container">
              <ul className="swiper-wrapper moreblogs_swiper_wrapper">
                {moreblogsList}
              </ul>
            </div>
            {width < 767 ? (
              <div className="arrows_wrapper">
                <div className="navigations">
                  <button className="left_arrow">Previous</button>
                  <button className="right_arrow">Next</button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section> */}
      {/* <FsLightbox toggler={toggler} sources={[vidLink]} /> */}
    </>
  );
};

export default BlogInner;
